import React from 'react';
import {PiWarningCircle} from 'react-icons/pi';
import styled from 'styled-components';

interface Props {
  error?: string;
  gridColumn?: number;
  children: React.ReactNode;
}

const ErrorWrapper: React.FC<Props> = ({error, gridColumn, children}) => {
  return (
    <Wrapper {...{gridColumn}}>
      {children}
      {error && (
        <ErrorContainer>
          <ErrorIcon />
          <ErrorLabel>{error}</ErrorLabel>
        </ErrorContainer>
      )}
    </Wrapper>
  );
};

export default ErrorWrapper;

interface WrapperProps {
  gridColumn?: number;
  border?: boolean;
  focused?: boolean;
}

export const Wrapper = styled.div<WrapperProps>`
  display: flex;
  flex-direction: column;
  gap: 5px;
  grid-column: ${({gridColumn}) => `span ${gridColumn ?? 12}`};
  position: relative;
`;

const ErrorContainer = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
`;

const ErrorLabel = styled.label`
  font-weight: 600;
  color: ${(props) => props.theme.colors.error};
  margin-left: 3px;
`;

const ErrorIcon = styled(PiWarningCircle)`
  color: ${(props) => props.theme.colors.error};
  height: 16px;
  width: 16px;
`;
